// import React from 'react';
// import { Autocomplete as MuiAutocomplete, TextField, FormControl } from '@mui/material';

// const CustomAutocomplete = React.forwardRef(
//   ({ 
//     options, 
//     value, 
//     onChange, 
//     disabled, 
//     error, 
//     helperText, 
//     onKeyDown, 
//     id, 
//     name, 
//     label,
//     inputProps = {}
//   }, ref) => {
//     return (
//       <FormControl fullWidth>
//         <MuiAutocomplete
//           id={id}
//           options={options}
//           getOptionLabel={(option) => option.Name || ''}
//           value={value}
//           onChange={(event, newValue) => {
//             onChange({
//               target: {
//                 name,
//                 value: newValue ? newValue.Id : ''
//               }
//             });
//           }}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               label={label}
//               variant="filled"
//               className="custom-textfield"
//               error={!!error}
//               helperText={helperText}
//               inputRef={ref}
//               onKeyDown={onKeyDown}
//               inputProps={{ ...params.inputProps, ...inputProps }}
//             />
//           )}
//           disabled={disabled}
//           className="custom-select"

//         />
//       </FormControl>
//     );
//   }
// );

// export default CustomAutocomplete;

import React from 'react';
import { Autocomplete, TextField, FormControl, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const CustomAutocomplete = React.forwardRef(
  ({
    options,
    value,
    onChange,
    disabled,
    error,
    helperText,
    onKeyDown,
    id,
    name,
    label,
    InputProps = {},
    endAdornment,
    variant = "filled",
    className = "custom-textfield"
  }, ref) => {
    // Determine if we should shrink the label (when there's a value or when focused)
    const [focused, setFocused] = React.useState(false);
    const shouldShrink = !!value || focused;

    return (
      <FormControl fullWidth variant={variant}>
        <Autocomplete
          id={id}
          options={options}
          getOptionLabel={(option) => option.Name || ''}
          value={value}
          onChange={(event, newValue) => {
            onChange({
              target: {
                name,
                value: newValue ? newValue.Id : ''
              }
            });
          }}
          clearOnBlur={false}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant={variant}
              className={className}
              error={!!error}
              helperText={helperText}
              inputRef={ref}
              onKeyDown={onKeyDown}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    {params.InputProps.startAdornment}
                  </>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {endAdornment}
                    {params.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                shrink: shouldShrink,
                sx: {
                  transformOrigin: 'top left',
                  ...(!shouldShrink && {
                    transform: 'translate(14px, 18px) scale(1)',
                    fontSize: '1rem'
                  })
                }
              }}
              sx={{
                '& .MuiInputLabel-filled': {
                  ...(!shouldShrink && {
                    transform: 'translate(14px, 18px) scale(1)'
                  })
                }
              }}
              fullWidth
            />
          )}
          disabled={disabled}
          sx={{
            "& .MuiAutocomplete-root": {
              backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper'
            }
          }}
        />
      </FormControl>
    );
  }
);

export default CustomAutocomplete;